<script setup lang="ts">
import { Skeleton, Markdown } from "@/components/Ui";
import { useRoute } from "vue-router";
type NavItem = {
  title: string;
  path: string;
};
type Props = {
  items?: NavItem[];
  pending?: boolean;
};
const route = useRoute();
const props = defineProps<Props>();
</script>

<template>
  <ul class="legal-nav">
    <template v-if="!props.pending">
      <li
        v-for="(item, index) in items"
        :key="index"
      >
        <nuxt-link
          :to="{ path: `/legal/${item.attributes.slug}` }"
          :title="item.attributes.title"
          :class="{ 'is-active': route.params.slug === item.attributes.slug }"
        >
          <Markdown
            :content="item.attributes.title"
            :position="
              route.params.slug === item.attributes.slug ? 'nav-active' : 'nav'
            "
          />
        </nuxt-link>
      </li>
    </template>
    <template v-else>
      <li
        v-for="index in 9"
        :key="index"
      >
        <Skeleton
          :pending="props.pending"
          :options="{ width: 230, height: 46 }"
        >
          <template #loader>
            <rect
              x="0"
              y="0"
              rx="12"
              ry="12"
              width="230"
              height="46"
            />
          </template>
          <a />
        </Skeleton>
      </li>
    </template>
  </ul>
</template>

<style lang="scss" scoped>
.legal-nav {
  @apply flex flex-col gap-[6px];
  & li {
    @apply flex w-full;
    & a {
      @apply relative px-4 py-3 text-[15px] w-full rounded-[12px] transition-all text-neutral-600 overflow-hidden flex items-center;
      @apply hover:bg-neutral-100;

      & p {
        @apply inline-flex gap-1;

        & .tang {
          @apply -translate-y-[0.4px];
        }
      }

      &.is-active,
      &.router-link-active {
        @apply bg-neutral-100 text-neutral-900;

        &:before {
          @apply absolute left-0 top-0 bg-neutral-900 w-[4px] h-full;
          content: "";
        }
      }
    }
  }
}
</style>
